export const ACTIVITIES = [
  { code: "alici", label: "Alıcı" },
  { code: "bosaltan", label: "Boşaltan" },
  { code: "gonderen", label: "Gönderen" },
  { code: "tasiyan", label: "Taşıyan" },
  { code: "dolduran", label: "Dolduran" },
  { code: "yukleyen", label: "Yükleyen" },
  { code: "paketleyen", label: "Paketleyen" },
  { code: "portatif_tank_konteyner", label: "Portatif Tank/Konteyner" },
];

export const ROLE_LABELS = {
  main_admin: "Ana Yönetici",
  org_manager: "Kuruluş Yöneticisi",
  advisor: "TMGD Danışmanı",
  customer: "Müşteri Yetkilisi",
};

export const KIND_LABELS = {
  ise_giris: "İşe Giriş",
  isten_ayrilma: "İşten Ayrılma",
  gorev_degisikligi: "Görev Değişikliği",
};

export const isManager = (role) => role === "main_admin" || role === "org_manager";
